var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFileGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34134 3.33299V3.33268C4.34134 2.68889 4.86241 2.16602 5.49967 2.16602H11.9592L16.6663 6.87312V16.666C16.6663 17.3065 16.1402 17.8327 15.4997 17.8327H5.49134C4.85412 17.8327 4.33309 17.3099 4.33301 16.6662C4.33301 16.6661 4.33301 16.6661 4.33301 16.666L4.34134 3.33299ZM15.4997 17.166H15.9997V16.666V7.49935V6.99935H15.4997H11.833V3.33268V2.83268H11.333H5.49967H4.99967V3.33268V16.666V17.166H5.49967H15.4997ZM7.87345 12.5077L10.5071 9.87401L13.128 12.508L12.6568 12.9827L11.6866 12.0125L10.833 11.1589V12.366V15.3327H10.1663V12.366V11.1643L9.3139 12.0113L8.34245 12.9767L7.87345 12.5077Z",
    fill: "black",
    stroke: "#96A397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileGrey);
export default __webpack_public_path__ + "static/media/upload_file_grey.d38b9cf75f6523c9def491d2c85c61ff.svg";
export { ForwardRef as ReactComponent };